import PageShell from '../../components/layout/PageShell';
import MasterDataPage from '../config/MasterDataPage';

export default function HomeBannersPage() {
  return (
    <PageShell>
      <MasterDataPage
        embedded
        catalogScope="common"
        singleTypeMode={{ groupKey: 'app_masters', typeKey: 'app_home_banners' }}
        pageTitle="Home Banners"
        pageSubtitle="Mobile app carousel banners"
      />
    </PageShell>
  );
}
